/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
    ActiveDirectoryGroup,
    Activity,
    ActivityDto,
    AddPowerhubServicePrincipalDTO,
    AddSecretParams,
    AdminProject,
    AggregatedUser,
    AppPackageGroup,
    ApprovalProjectapprovalGetProjectManagerApprovalsForMonthListParams,
    ApproverCellDetailLine,
    ApproverCustomFiltersRequest,
    ApproverLinesCustomPeriod,
    AssignmentPreviewDto,
    AssignmentPreviewRequest,
    Calendar,
    CalendarHolidays,
    ChartDataPeriod,
    ChartsProjectsListParams,
    ChartsUserchartdatabyweekListParams,
    ColumnDto,
    Config,
    ConfigurationActivitiesBulkCreatePayload,
    ConfigurationActivitiesDeleteParams,
    ConfigurationActivitiesDetailParams,
    ConfigurationActivitiesUpdateParams,
    ConfigurationCalendarsHolidaysListParams,
    ConfigurationDetailParams,
    CopyTime,
    CopyTimeEntriesFromPreviousUserPeriodParams,
    CorrectionDto,
    CorrectionWithTimeEntryDto,
    CreateActivityDto,
    CreateCorrectionWithTimeEntryRequest,
    CreateNewConfigurationParams,
    CreateTimeEntryCorrectionRequest,
    CreateTimeEntryRequest,
    CreateTrialDatabaseDto,
    CronValidatorPayload,
    DataverseEnvironment,
    DataverseEnvironmentsTablesColumnsListParams,
    DataverseEnvironmentsTablesColumnsOptionsListParams,
    DataverseEnvironmentsTablesColumnsOptionsetMetadataListParams,
    DataverseEnvironmentsTablesListParams,
    DataverseIntegration,
    DataverseProjectType,
    Delegate,
    DelegationPayload,
    DeleteParams,
    DeleteUserDto,
    EnableScheduleWebJobPayload,
    EnvironmentOptions,
    FrequentQuestion,
    GetAdminProjectsParams,
    GetAllPeriodsAsAdminPeriodsParams,
    GetAllProjectTypesParams,
    GetAllowedWorkTypesParams,
    GetApproverLineByUserCustomPeriodDto,
    GetApproverLinesByManagerCustomPeriodParams,
    GetAuditReportParams,
    GetChartsParams,
    GetDelegatesForUserParams,
    GetDelegatesParams,
    GetPeriodsByDatesParams,
    GetSbomParams,
    GetScheduleJobPayload,
    GetSupportersParams,
    GetTimeRowsMobileParams,
    GetTotalHoursResponseDto,
    GetUserPeriodByDateParams,
    GetVideosParams,
    GlobalOptionSetDefinitionResponse,
    GuidDto,
    Guide,
    HelpFrequentQuestionsCreatePayload,
    IScheduleJob,
    ImportActualsCreateParams,
    ImportTimeEntryPayload,
    InitialData,
    IntegrationCatchAllDto,
    IntegrationCreateRequest,
    IntegrationDto,
    IntegrationEventDeleteParams,
    IntegrationEventDetailParams,
    IntegrationEventUpsertRequest,
    IntegrationPowerhubDataListParams,
    LoginDatabaseDto,
    MakeDefaultPayload,
    MetadataTable,
    MicrosoftEntraIdIntegration,
    OkObjectResult,
    OrgIdContainer,
    OrganizationsDTO,
    PFServiceBusConfiguration,
    PFServiceBusTopicOptions,
    PMChartDataProject,
    PaginatedDataResponse,
    Period,
    PeriodCreation,
    PeriodDto,
    PowerAutomateFlowValidationRequest,
    PowerAutomateValidationResponse,
    PowerPPMSyncConfig,
    ProblemDetails,
    Project,
    ProjectApprovalData,
    ProjectSource,
    ProjectumProblemDetails,
    QueryDataDTO,
    RegisterMultipleTimeEntriesDto,
    RegisterTimeByPeriodDayDto,
    RegisterTimeDto,
    RenameApproverCustomFilterDto,
    ReportPeriodDto,
    SearchAllTasksAdminOnlyParams,
    SearchAssignedParams,
    SearchTasksParams,
    SearchUsersParams,
    ServiceBusConnection,
    ServicebusClientDeleteParams,
    ServicebusClientDisableCreateParams,
    ServicebusClientEnableCreateParams,
    ServicebusClientInitializeCreateParams,
    ServicebusClientRulesDeleteParams,
    ServicebusClientRulesListParams,
    ServicebusClientRulesUpdateParams,
    ServicebusClientStartCreateParams,
    ServicebusClientTopicUpdateParams,
    ServicebusClientUpdateParams,
    ServicebusClientUpdatePayload,
    ServicebusInitializeCreatePayload,
    SetAdminProjectsPayload,
    SetAdminProjectsSourceDto,
    SetApprovedHoursForApprovalDto,
    SetApproverDto,
    SetAutoApproveDto,
    SetCalendarsPayload,
    SetConfigDto,
    SetCustomRateForApprovalDto,
    SetDelegatesDto,
    SetIsAdminDto,
    SetMultipleCustomRateForApprovalDto,
    SetMultipleTimeEntryApprovalActivityDto,
    SetMultipleTimeEntryApprovalStateDto,
    SetPeriodStateDto,
    SetPinnedDto,
    SetSupportersPayload,
    SetTimeEntryApprovalActivityDto,
    SetTimeEntryApprovalStateDto,
    SetUserAdministrationDto,
    SetUserPeriodStateDto,
    SetVideosPayload,
    SetWorkDayStartEndDto,
    SubscriptionRuleCreation,
    SubscriptionRuleDeletion,
    Supporter,
    TableDto,
    TeamPlannerIntegration,
    TenantNotFoundProblem,
    TimeConfiguration,
    TimeEntry,
    TimeEntryAdminCreatedDto,
    TimeEntryCorrectionData,
    TimeEntryCorrectionsDetailParams,
    TimeEntryCorrectionsTimeEntryDetailParams,
    TimeEntryCorrectionsWithinDatesListParams,
    TimeEntryError,
    TimeRegistrationResult,
    TimeRowMobile,
    TimeSearchRow,
    TimeUser,
    TimeUserFeatures,
    TimeVersion,
    TopicRuleContainer,
    UpdateActivityDto,
    UpdateRemainingWorkDto,
    UpgradeController,
    UpgradeGetControllerParams,
    UpgradeGetPackagesParams,
    UpgradePackageGroup,
    UpgradePackagesPayload,
    UserRegistrationPeriod,
    UserReportingPeriodComment,
    UsersAssignmentsTotalHoursListParams,
    UsersCalendarListParams,
    VersioningReleasenotesDetailParams,
    Video,
    WorkProjectType,
    WorkType,
    WorkTypeChangeDto,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientStartCreate
     * @request POST:/api/servicebus/client/{configurationKey}/start
     * @secure
     * @response `200` `void` OK
     * @response `404` `ProblemDetails` Not Found
     */
    servicebusClientStartCreate = ({ configurationKey }: ServicebusClientStartCreateParams, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/servicebus/client/${configurationKey}/start`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientTopicUpdate
     * @request PUT:/api/servicebus/client/{configurationKey}/topic
     * @secure
     * @response `200` `void` OK
     * @response `404` `ProblemDetails` Not Found
     */
    servicebusClientTopicUpdate = (
        { configurationKey, ...query }: ServicebusClientTopicUpdateParams,
        body: PFServiceBusTopicOptions,
        params: RequestParams = {},
    ) =>
        this.request<void, ProblemDetails>({
            path: `/api/servicebus/client/${configurationKey}/topic`,
            method: 'PUT',
            query: query,
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientEnableCreate
     * @request POST:/api/servicebus/client/{configurationKey}/enable
     * @secure
     * @response `200` `void` OK
     */
    servicebusClientEnableCreate = ({ configurationKey }: ServicebusClientEnableCreateParams, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/client/${configurationKey}/enable`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientDisableCreate
     * @request POST:/api/servicebus/client/{configurationKey}/disable
     * @secure
     * @response `200` `void` OK
     */
    servicebusClientDisableCreate = ({ configurationKey }: ServicebusClientDisableCreateParams, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/client/${configurationKey}/disable`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientRulesList
     * @request GET:/api/servicebus/client/{configurationKey}/rules
     * @secure
     * @response `200` `(TopicRuleContainer)[]` OK
     * @response `404` `ProblemDetails` Not Found
     */
    servicebusClientRulesList = ({ configurationKey }: ServicebusClientRulesListParams, params: RequestParams = {}) =>
        this.request<TopicRuleContainer[], ProblemDetails>({
            path: `/api/servicebus/client/${configurationKey}/rules`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientRulesUpdate
     * @request PUT:/api/servicebus/client/{configurationKey}/rules
     * @secure
     * @response `200` `void` OK
     */
    servicebusClientRulesUpdate = ({ configurationKey }: ServicebusClientRulesUpdateParams, body: SubscriptionRuleCreation, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/client/${configurationKey}/rules`,
            method: 'PUT',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags {Configurationkey}
     * @name ServicebusClientRulesDelete
     * @request DELETE:/api/servicebus/client/{configurationKey}/rules
     * @secure
     * @response `200` `(TopicRuleContainer)[]` OK
     */
    servicebusClientRulesDelete = ({ configurationKey }: ServicebusClientRulesDeleteParams, body: SubscriptionRuleDeletion, params: RequestParams = {}) =>
        this.request<TopicRuleContainer[], any>({
            path: `/api/servicebus/client/${configurationKey}/rules`,
            method: 'DELETE',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Aad
     * @name IntegrationAadEnablescheduleCreate
     * @request POST:/api/integration/aad/enableschedule
     * @secure
     * @response `200` `void` OK
     */
    integrationAadEnablescheduleCreate = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/aad/enableschedule`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Aad
     * @name IntegrationAadSyncusersCreate
     * @request POST:/api/integration/aad/syncusers
     * @secure
     * @response `200` `void` OK
     */
    integrationAadSyncusersCreate = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/aad/syncusers`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * @description 5881EFAE-FE4F-4C88-B66B-2B8D31D88192
     *
     * @tags Aad
     * @name IntegrationAadSyncusersscheduledCreate
     * @request POST:/api/integration/aad/syncusersscheduled
     * @secure
     * @response `200` `void` OK
     */
    integrationAadSyncusersscheduledCreate = (body: OrgIdContainer, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/aad/syncusersscheduled`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Aad
     * @name IntegrationAadSyncusersdeltaCreate
     * @request POST:/api/integration/aad/syncusersdelta
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    integrationAadSyncusersdeltaCreate = (body: OrgIdContainer, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/integration/aad/syncusersdelta`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Activities
     * @name ConfigurationActivitiesDetail
     * @request GET:/api/configuration/activities/{id}
     * @secure
     * @response `200` `ActivityDto` OK
     * @response `404` `ProblemDetails` Not Found
     */
    configurationActivitiesDetail = ({ id }: ConfigurationActivitiesDetailParams, params: RequestParams = {}) =>
        this.request<ActivityDto, ProblemDetails>({
            path: `/api/configuration/activities/${id}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Activities
     * @name ConfigurationActivitiesUpdate
     * @request PUT:/api/configuration/activities/{id}
     * @secure
     * @response `200` `ActivityDto` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    configurationActivitiesUpdate = ({ id }: ConfigurationActivitiesUpdateParams, body: UpdateActivityDto, params: RequestParams = {}) =>
        this.request<ActivityDto, ProblemDetails>({
            path: `/api/configuration/activities/${id}`,
            method: 'PUT',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Activities
     * @name ConfigurationActivitiesDelete
     * @request DELETE:/api/configuration/activities/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     * @response `409` `ProblemDetails` Conflict
     */
    configurationActivitiesDelete = ({ id }: ConfigurationActivitiesDeleteParams, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/configuration/activities/${id}`,
            method: 'DELETE',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Activities
     * @name ConfigurationActivitiesBulkCreate
     * @request POST:/api/configuration/activities/bulk
     * @secure
     * @response `200` `(ActivityDto)[]` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    configurationActivitiesBulkCreate = (body: ConfigurationActivitiesBulkCreatePayload, params: RequestParams = {}) =>
        this.request<ActivityDto[], ProblemDetails>({
            path: `/api/configuration/activities/bulk`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Admin
     * @name GetAllPeriodsAsAdminPeriods
     * @request GET:/api/admin/getAllPeriodsAsAdminPeriods
     * @secure
     * @response `200` `(Period)[]` OK
     */
    getAllPeriodsAsAdminPeriods = (query: GetAllPeriodsAsAdminPeriodsParams = {}, params: RequestParams = {}) =>
        this.request<Period[], any>({
            path: `/api/admin/getAllPeriodsAsAdminPeriods`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description 33B2136D-237F-4FAD-B4ED-C4D126E88655
     *
     * @tags Admin
     * @name SetPeriodState
     * @request POST:/api/admin/setPeriodState
     * @secure
     * @response `200` `SetPeriodStateDto` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setPeriodState = (body: SetPeriodStateDto, params: RequestParams = {}) =>
        this.request<SetPeriodStateDto, ProblemDetails>({
            path: `/api/admin/setPeriodState`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Admin
     * @name SetAdminProjectsSource
     * @request POST:/api/admin/setAdminProjectsSource
     * @secure
     * @response `200` `void` OK
     */
    setAdminProjectsSource = (body: SetAdminProjectsSourceDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/admin/setAdminProjectsSource`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name ConfigurationList
     * @request GET:/api/configuration
     * @secure
     * @response `200` `(Config)[]` OK
     */
    configurationList = (params: RequestParams = {}) =>
        this.request<Config[], any>({
            path: `/api/configuration`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name User
     * @request GET:/api/user
     * @secure
     * @response `200` `AggregatedUser` OK
     * @response `404` `ProblemDetails` Not Found
     */
    user = (params: RequestParams = {}) =>
        this.request<AggregatedUser, ProblemDetails>({
            path: `/api/user`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name TrialCreate
     * @request POST:/api/trial
     * @secure
     * @response `200` `void` OK
     */
    trialCreate = (body: CreateTrialDatabaseDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/trial`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name TimeEntryCorrectionsCreate
     * @request POST:/api/time-entry-corrections
     * @secure
     * @response `201` `CorrectionDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    timeEntryCorrectionsCreate = (body: CreateTimeEntryCorrectionRequest, params: RequestParams = {}) =>
        this.request<CorrectionDto, ProblemDetails>({
            path: `/api/time-entry-corrections`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name IntegrationEventList
     * @request GET:/api/IntegrationEvent
     * @secure
     * @response `200` `(IntegrationDto)[]` OK
     */
    integrationEventList = (params: RequestParams = {}) =>
        this.request<IntegrationDto[], any>({
            path: `/api/IntegrationEvent`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name IntegrationEventCreate
     * @request POST:/api/IntegrationEvent
     * @secure
     * @response `201` `IntegrationDto` Created
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    integrationEventCreate = (body: IntegrationCreateRequest, params: RequestParams = {}) =>
        this.request<IntegrationDto, ProjectumProblemDetails>({
            path: `/api/IntegrationEvent`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name IntegrationEventUpdate
     * @request PUT:/api/IntegrationEvent
     * @secure
     * @response `200` `IntegrationDto` OK
     * @response `404` `ProblemDetails` Not Found
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    integrationEventUpdate = (body: IntegrationEventUpsertRequest, params: RequestParams = {}) =>
        this.request<IntegrationDto, ProblemDetails | ProjectumProblemDetails>({
            path: `/api/IntegrationEvent`,
            method: 'PUT',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Api
     * @name EnvironmentList
     * @request GET:/api/environment
     * @secure
     * @response `200` `EnvironmentOptions` OK
     */
    environmentList = (params: RequestParams = {}) =>
        this.request<EnvironmentOptions, any>({
            path: `/api/environment`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approver
     * @name GetApproverLineByCustomPeriod
     * @request POST:/api/approver/getApproverLineByCustomPeriod
     * @secure
     * @response `200` `(ApproverCellDetailLine)[]` OK
     */
    getApproverLineByCustomPeriod = (body: GetApproverLineByUserCustomPeriodDto, params: RequestParams = {}) =>
        this.request<ApproverCellDetailLine[], any>({
            path: `/api/approver/getApproverLineByCustomPeriod`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * @description 4171DDCA-47E9-4ACD-94A7-1AF59333F764
     *
     * @tags Approver
     * @name GetApproverLinesByManagerCustomPeriod
     * @request GET:/api/approver/getApproverLinesByManagerCustomPeriod
     * @secure
     * @response `200` `(ApproverLinesCustomPeriod)[]` OK
     */
    getApproverLinesByManagerCustomPeriod = (query: GetApproverLinesByManagerCustomPeriodParams = {}, params: RequestParams = {}) =>
        this.request<ApproverLinesCustomPeriod[], any>({
            path: `/api/approver/getApproverLinesByManagerCustomPeriod`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description Get periods where the approver has outstanding work to approve
     *
     * @tags Approver
     * @name GetMissingApprovals
     * @request GET:/api/approver/missingApprovals
     * @secure
     * @response `200` `(Period)[]` OK
     */
    getMissingApprovals = (params: RequestParams = {}) =>
        this.request<Period[], any>({
            path: `/api/approver/missingApprovals`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilter
     * @name GetByUser
     * @request GET:/api/approverfilter/getByUser
     * @secure
     * @response `200` `(ApproverCustomFiltersRequest)[]` OK
     * @response `400` `ProblemDetails` Bad Request
     */
    getByUser = (params: RequestParams = {}) =>
        this.request<ApproverCustomFiltersRequest[], ProblemDetails>({
            path: `/api/approverfilter/getByUser`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilter
     * @name SaveApprover
     * @request POST:/api/approverfilter/saveApprover
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    saveApprover = (body: ApproverCustomFiltersRequest, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/approverfilter/saveApprover`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilter
     * @name MakeDefault
     * @request POST:/api/approverfilter/setdefault
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    makeDefault = (body: MakeDefaultPayload, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/approverfilter/setdefault`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilter
     * @name Save
     * @request POST:/api/approverfilter/save
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     */
    save = (body: ApproverCustomFiltersRequest, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approverfilter/save`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilters
     * @name Delete
     * @request POST:/api/approverfilters/delete
     * @secure
     * @response `200` `void` OK
     * @response `404` `ProblemDetails` Not Found
     */
    delete = (query: DeleteParams = {}, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approverfilters/delete`,
            method: 'POST',
            query: query,
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Approverfilters
     * @name RenameApproverCustomFilter
     * @request POST:/api/approverfilters/rename
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     */
    renameApproverCustomFilter = (body: RenameApproverCustomFilterDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approverfilters/rename`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Assignments
     * @name ChangeWorkTypeFromKey
     * @request POST:/api/users/assignments/changeWorkTypeFromKey
     * @secure
     * @response `200` `boolean` OK
     */
    changeWorkTypeFromKey = (body: WorkTypeChangeDto, params: RequestParams = {}) =>
        this.request<boolean, any>({
            path: `/api/users/assignments/changeWorkTypeFromKey`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Assignments
     * @name UsersAssignmentsTotalHoursList
     * @summary Get total hours registered for a task by the current user
     * @request GET:/api/users/assignments/totalHours
     * @secure
     * @response `200` `GetTotalHoursResponseDto` OK
     */
    usersAssignmentsTotalHoursList = (query: UsersAssignmentsTotalHoursListParams, params: RequestParams = {}) =>
        this.request<GetTotalHoursResponseDto, any>({
            path: `/api/users/assignments/totalHours`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Assignments
     * @name UsersAssignmentsRemainingWorkUpdate
     * @summary Update remaining work for an assignment
     * @request PUT:/api/users/assignments/remainingWork
     * @secure
     * @response `200` `void` OK
     */
    usersAssignmentsRemainingWorkUpdate = (body: UpdateRemainingWorkDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/users/assignments/remainingWork`,
            method: 'PUT',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * @description Gets audit report for a specific version.
     *
     * @tags Audit
     * @name GetAuditReport
     * @request GET:/api/package-artifacts/audit/{version}
     * @secure
     * @response `200` `string` OK
     * @response `404` `ProblemDetails` Not Found
     */
    getAuditReport = ({ version }: GetAuditReportParams, params: RequestParams = {}) =>
        this.request<string, ProblemDetails>({
            path: `/api/package-artifacts/audit/${version}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description 0B114B60-9D9C-4632-A50C-9C7410C73469
     *
     * @tags Calendars
     * @name ConfigurationCalendarsHolidaysList
     * @request GET:/api/configuration/calendars/holidays
     * @secure
     * @response `200` `(CalendarHolidays)[]` OK
     */
    configurationCalendarsHolidaysList = (query: ConfigurationCalendarsHolidaysListParams = {}, params: RequestParams = {}) =>
        this.request<CalendarHolidays[], any>({
            path: `/api/configuration/calendars/holidays`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Calendars
     * @name SetCalendars
     * @request POST:/api/configuration/calendars/set
     * @secure
     * @response `200` `void` OK
     */
    setCalendars = (body: SetCalendarsPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/configuration/calendars/set`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Charts
     * @name GetCharts
     * @request GET:/api/charts/getCharts
     * @secure
     * @response `200` `PMChartDataProject` OK
     */
    getCharts = (query: GetChartsParams = {}, params: RequestParams = {}) =>
        this.request<PMChartDataProject, any>({
            path: `/api/charts/getCharts`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Charts
     * @name ChartsProjectsList
     * @request GET:/api/charts/projects
     * @secure
     * @response `200` `(Project)[]` OK
     */
    chartsProjectsList = (query: ChartsProjectsListParams = {}, params: RequestParams = {}) =>
        this.request<Project[], any>({
            path: `/api/charts/projects`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Charts
     * @name ChartsUserchartdatabyweekList
     * @request GET:/api/charts/userchartdatabyweek
     * @secure
     * @response `200` `(ChartDataPeriod)[]` OK
     */
    chartsUserchartdatabyweekList = (query: ChartsUserchartdatabyweekListParams = {}, params: RequestParams = {}) =>
        this.request<ChartDataPeriod[], any>({
            path: `/api/charts/userchartdatabyweek`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Client
     * @name ServicebusClientUpdate
     * @request PUT:/api/servicebus/client/{configurationName}
     * @secure
     * @response `200` `(PFServiceBusConfiguration)[]` OK
     */
    servicebusClientUpdate = ({ configurationName }: ServicebusClientUpdateParams, body: ServicebusClientUpdatePayload, params: RequestParams = {}) =>
        this.request<PFServiceBusConfiguration[], any>({
            path: `/api/servicebus/client/${configurationName}`,
            method: 'PUT',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Client
     * @name ServicebusClientDelete
     * @request DELETE:/api/servicebus/client/{configurationKey}
     * @secure
     * @response `200` `void` OK
     */
    servicebusClientDelete = ({ configurationKey }: ServicebusClientDeleteParams, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/client/${configurationKey}`,
            method: 'DELETE',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Columns
     * @name DataverseEnvironmentsTablesColumnsOptionsList
     * @request GET:/api/dataverse/environments/tables/columns/options
     * @secure
     * @response `200` `(ColumnDto)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseEnvironmentsTablesColumnsOptionsList = (query: DataverseEnvironmentsTablesColumnsOptionsListParams = {}, params: RequestParams = {}) =>
        this.request<ColumnDto[], ProjectumProblemDetails>({
            path: `/api/dataverse/environments/tables/columns/options`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Columns
     * @name DataverseEnvironmentsTablesColumnsOptionsetMetadataList
     * @request GET:/api/dataverse/environments/tables/columns/optionset-metadata
     * @secure
     * @response `200` `GlobalOptionSetDefinitionResponse` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseEnvironmentsTablesColumnsOptionsetMetadataList = (
        query: DataverseEnvironmentsTablesColumnsOptionsetMetadataListParams = {},
        params: RequestParams = {},
    ) =>
        this.request<GlobalOptionSetDefinitionResponse, ProjectumProblemDetails>({
            path: `/api/dataverse/environments/tables/columns/optionset-metadata`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description Creates a KeyVault secret containing the Service Bus configuration, based on an already configured Service Bus, using the Service Bus name
     *
     * @tags Configuration
     * @name AddSecret
     * @summary Create secret from Service Bus
     * @request POST:/api/servicebus/configuration/addSecret
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    addSecret = (query: AddSecretParams = {}, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/servicebus/configuration/addSecret`,
            method: 'POST',
            query: query,
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name CreateNewConfiguration
     * @request POST:/api/servicebus/configuration/createConfig
     * @secure
     * @response `200` `void` OK
     */
    createNewConfiguration = (query: CreateNewConfigurationParams = {}, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/configuration/createConfig`,
            method: 'POST',
            query: query,
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name EnsureApplicationAppKey
     * @request GET:/api/configuration/ensureappinsightskey
     * @secure
     * @response `200` `void` OK
     * @response `503` `void` Service Unavailable
     */
    ensureApplicationAppKey = (params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/configuration/ensureappinsightskey`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationBasicList
     * @request GET:/api/configuration/basic
     * @secure
     * @response `200` `TimeUserFeatures` OK
     */
    configurationBasicList = (params: RequestParams = {}) =>
        this.request<TimeUserFeatures, any>({
            path: `/api/configuration/basic`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationBasicCreate
     * @request POST:/api/configuration/basic
     * @secure
     * @response `200` `void` OK
     */
    configurationBasicCreate = (body: TimeUserFeatures, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/configuration/basic`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationFullList
     * @request GET:/api/configuration/full
     * @secure
     * @response `200` `TimeConfiguration` OK
     */
    configurationFullList = (params: RequestParams = {}) =>
        this.request<TimeConfiguration, any>({
            path: `/api/configuration/full`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationFullCreate
     * @request POST:/api/configuration/full
     * @secure
     * @response `200` `void` OK
     */
    configurationFullCreate = (body: TimeConfiguration, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/configuration/full`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationDetail
     * @request GET:/api/configuration/{key}
     * @secure
     * @response `200` `Config` OK
     */
    configurationDetail = ({ key }: ConfigurationDetailParams, params: RequestParams = {}) =>
        this.request<Config, any>({
            path: `/api/configuration/${key}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationGetcachedList
     * @request GET:/api/configuration/getcached
     * @secure
     * @response `200` `(Config)[]` OK
     * @response `404` `TenantNotFoundProblem` Not Found
     */
    configurationGetcachedList = (params: RequestParams = {}) =>
        this.request<Config[], TenantNotFoundProblem>({
            path: `/api/configuration/getcached`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description 1C923F3F-CA48-48D7-A190-2B67C5455C0A
     *
     * @tags Configuration
     * @name ConfigurationGetPowerPpmSyncConfigList
     * @request GET:/api/configuration/getPowerPPMSyncConfig
     * @secure
     * @response `200` `PowerPPMSyncConfig` OK
     */
    configurationGetPowerPpmSyncConfigList = (params: RequestParams = {}) =>
        this.request<PowerPPMSyncConfig, any>({
            path: `/api/configuration/getPowerPPMSyncConfig`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description 98BA0105-BB22-4679-B92D-AD431ED5CBA7
     *
     * @tags Configuration
     * @name GetTimeForTeamsVersion
     * @request GET:/api/configuration/version
     * @secure
     * @response `200` `TimeVersion` OK
     */
    getTimeForTeamsVersion = (params: RequestParams = {}) =>
        this.request<TimeVersion, any>({
            path: `/api/configuration/version`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationUpsertCreate
     * @request POST:/api/configuration/upsert
     * @secure
     * @response `200` `void` OK
     */
    configurationUpsertCreate = (body: SetConfigDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/configuration/upsert`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationCalendarsList
     * @request GET:/api/configuration/calendars
     * @secure
     * @response `200` `(Calendar)[]` OK
     */
    configurationCalendarsList = (params: RequestParams = {}) =>
        this.request<Calendar[], any>({
            path: `/api/configuration/calendars`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationActivitiesList
     * @request GET:/api/configuration/activities
     * @secure
     * @response `200` `(ActivityDto)[]` OK
     */
    configurationActivitiesList = (params: RequestParams = {}) =>
        this.request<ActivityDto[], any>({
            path: `/api/configuration/activities`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Configuration
     * @name ConfigurationActivitiesCreate
     * @request POST:/api/configuration/activities
     * @secure
     * @response `201` `ActivityDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    configurationActivitiesCreate = (body: CreateActivityDto, params: RequestParams = {}) =>
        this.request<ActivityDto, ProblemDetails>({
            path: `/api/configuration/activities`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Controller
     * @name UpgradeGetController
     * @request GET:/api/framework/upgrade/controller/{upgradeController}
     * @secure
     * @response `200` `(UpgradeController)[]` OK
     */
    upgradeGetController = ({ upgradeController }: UpgradeGetControllerParams, params: RequestParams = {}) =>
        this.request<UpgradeController[], any>({
            path: `/api/framework/upgrade/controller/${upgradeController}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Dataverse
     * @name DataverseEnvironmentsList
     * @request GET:/api/dataverse/environments
     * @secure
     * @response `200` `(DataverseEnvironment)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseEnvironmentsList = (params: RequestParams = {}) =>
        this.request<DataverseEnvironment[], ProjectumProblemDetails>({
            path: `/api/dataverse/environments`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Dataverse
     * @name DataverseProjectTypesList
     * @request GET:/api/dataverse/project-types
     * @secure
     * @response `200` `(DataverseProjectType)[]` OK
     */
    dataverseProjectTypesList = (params: RequestParams = {}) =>
        this.request<DataverseProjectType[], any>({
            path: `/api/dataverse/project-types`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Delegation
     * @name Activate
     * @request POST:/api/users/delegation/activate
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    activate = (body: DelegationPayload, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/users/delegation/activate`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Delegation
     * @name GetDelegates
     * @request GET:/api/users/delegation/get
     * @secure
     * @response `200` `(Delegate)[]` OK
     */
    getDelegates = (query: GetDelegatesParams = {}, params: RequestParams = {}) =>
        this.request<Delegate[], any>({
            path: `/api/users/delegation/get`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description A12C62E9-DF97-4F7C-8474-DDB330E7C42D
     *
     * @tags Delegation
     * @name SetDelegates
     * @request POST:/api/users/delegation/set
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setDelegates = (body: SetDelegatesDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/users/delegation/set`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Download
     * @name DownloadMsteamsappList
     * @request GET:/api/download/msteamsapp
     * @secure
     * @response `200` `File` OK
     * @response `500` `OkObjectResult` Internal Server Error
     */
    downloadMsteamsappList = (params: RequestParams = {}) =>
        this.request<Blob, OkObjectResult>({
            path: `/api/download/msteamsapp`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Environments
     * @name DataverseEnvironmentsTablesList
     * @request GET:/api/dataverse/environments/tables
     * @secure
     * @response `200` `(TableDto)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseEnvironmentsTablesList = (query: DataverseEnvironmentsTablesListParams = {}, params: RequestParams = {}) =>
        this.request<TableDto[], ProjectumProblemDetails>({
            path: `/api/dataverse/environments/tables`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Framework
     * @name UpgradeGetCurrent
     * @request GET:/api/framework/upgrade
     * @secure
     * @response `200` `(AppPackageGroup)[]` OK
     */
    upgradeGetCurrent = (params: RequestParams = {}) =>
        this.request<AppPackageGroup[], any>({
            path: `/api/framework/upgrade`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Framework
     * @name UpgradePackages
     * @request POST:/api/framework/upgrade
     * @secure
     * @response `200` `void` OK
     */
    upgradePackages = (body: UpgradePackagesPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/framework/upgrade`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Get
     * @name GetDelegatesForUser
     * @request GET:/api/users/delegation/get/{userId}
     * @secure
     * @response `200` `(TimeUser)[]` OK
     */
    getDelegatesForUser = ({ userId }: GetDelegatesForUserParams, params: RequestParams = {}) =>
        this.request<TimeUser[], any>({
            path: `/api/users/delegation/get/${userId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name FrequentQuestions
     * @request GET:/api/help/frequentQuestions
     * @secure
     * @response `200` `(FrequentQuestion)[]` OK
     */
    frequentQuestions = (params: RequestParams = {}) =>
        this.request<FrequentQuestion[], any>({
            path: `/api/help/frequentQuestions`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name HelpFrequentQuestionsCreate
     * @request POST:/api/help/frequentQuestions
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    helpFrequentQuestionsCreate = (body: HelpFrequentQuestionsCreatePayload, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/help/frequentQuestions`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name Guides
     * @request GET:/api/help/getGuides
     * @secure
     * @response `200` `(Guide)[]` OK
     */
    guides = (params: RequestParams = {}) =>
        this.request<Guide[], any>({
            path: `/api/help/getGuides`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name GetSupporters
     * @request GET:/api/help/getSupporters
     * @secure
     * @response `200` `(Supporter)[]` OK
     */
    getSupporters = (query: GetSupportersParams = {}, params: RequestParams = {}) =>
        this.request<Supporter[], any>({
            path: `/api/help/getSupporters`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name GetVideos
     * @request GET:/api/help/getVideos
     * @secure
     * @response `200` `(Video)[]` OK
     */
    getVideos = (query: GetVideosParams = {}, params: RequestParams = {}) =>
        this.request<Video[], any>({
            path: `/api/help/getVideos`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Help
     * @name SetSupporters
     * @request POST:/api/help/setSupporters
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setSupporters = (body: SetSupportersPayload, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/help/setSupporters`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * @description 40C92CDD-FB5C-4161-9342-F8F7F20109C2
     *
     * @tags Help
     * @name SetVideos
     * @request POST:/api/help/setVideos
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setVideos = (body: SetVideosPayload, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/help/setVideos`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Import
     * @name ImportActualsCreate
     * @request POST:/api/import/actuals
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    importActualsCreate = (query: ImportActualsCreateParams = {}, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/import/actuals`,
            method: 'POST',
            query: query,
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Import
     * @name ImportTimeEntry
     * @request POST:/api/import/upload
     * @secure
     * @response `200` `(TimeEntryError)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    importTimeEntry = (data: ImportTimeEntryPayload, params: RequestParams = {}) =>
        this.request<TimeEntryError[], ProjectumProblemDetails>({
            path: `/api/import/upload`,
            method: 'POST',
            body: data,
            secure: true,
            type: 'multipart/form-data',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Initialization
     * @name GetInitialData
     * @request GET:/api/initialization/get
     * @secure
     * @response `200` `InitialData` OK
     */
    getInitialData = (params: RequestParams = {}) =>
        this.request<InitialData, any>({
            path: `/api/initialization/get`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Initialize
     * @name ServicebusClientInitializeCreate
     * @request POST:/api/servicebus/client/{configurationKey}/initialize/{configurationName}
     * @secure
     * @response `200` `void` OK
     */
    servicebusClientInitializeCreate = ({ configurationKey, configurationName }: ServicebusClientInitializeCreateParams, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/client/${configurationKey}/initialize/${configurationName}`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationevent
     * @name IntegrationEventDetail
     * @request GET:/api/IntegrationEvent/{id}
     * @secure
     * @response `200` `IntegrationDto` OK
     * @response `404` `ProblemDetails` Not Found
     */
    integrationEventDetail = ({ id }: IntegrationEventDetailParams, params: RequestParams = {}) =>
        this.request<IntegrationDto, ProblemDetails>({
            path: `/api/IntegrationEvent/${id}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationevent
     * @name IntegrationEventDelete
     * @request DELETE:/api/IntegrationEvent/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `404` `ProblemDetails` Not Found
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    integrationEventDelete = ({ id }: IntegrationEventDeleteParams, params: RequestParams = {}) =>
        this.request<void, ProblemDetails | ProjectumProblemDetails>({
            path: `/api/IntegrationEvent/${id}`,
            method: 'DELETE',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationevent
     * @name IntegrationEventDataverseIntegrationTypeList
     * @request GET:/api/IntegrationEvent/dataverseIntegrationType
     * @secure
     * @response `200` `DataverseIntegration` OK
     */
    integrationEventDataverseIntegrationTypeList = (params: RequestParams = {}) =>
        this.request<DataverseIntegration, any>({
            path: `/api/IntegrationEvent/dataverseIntegrationType`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationevent
     * @name IntegrationEventMicrosoftEntraIdIntegrationTypeList
     * @request GET:/api/IntegrationEvent/microsoftEntraIdIntegrationType
     * @secure
     * @response `200` `MicrosoftEntraIdIntegration` OK
     */
    integrationEventMicrosoftEntraIdIntegrationTypeList = (params: RequestParams = {}) =>
        this.request<MicrosoftEntraIdIntegration, any>({
            path: `/api/IntegrationEvent/microsoftEntraIdIntegrationType`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationevent
     * @name IntegrationEventTeamPlannerIntegrationTypeList
     * @request GET:/api/IntegrationEvent/teamPlannerIntegrationType
     * @secure
     * @response `200` `TeamPlannerIntegration` OK
     */
    integrationEventTeamPlannerIntegrationTypeList = (params: RequestParams = {}) =>
        this.request<TeamPlannerIntegration, any>({
            path: `/api/IntegrationEvent/teamPlannerIntegrationType`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Integrationeventtype
     * @name SynchronizationIntegrationeventtypeGetCreate
     * @request POST:/api/synchronization/integrationeventtype/get
     * @secure
     * @response `200` `IntegrationCatchAllDto` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    synchronizationIntegrationeventtypeGetCreate = (params: RequestParams = {}) =>
        this.request<IntegrationCatchAllDto, ProblemDetails>({
            path: `/api/synchronization/integrationeventtype/get`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Mobile
     * @name GetTimeRowsMobile
     * @request GET:/api/mobile/rows
     * @secure
     * @response `200` `(TimeRowMobile)[]` OK
     */
    getTimeRowsMobile = (query: GetTimeRowsMobileParams = {}, params: RequestParams = {}) =>
        this.request<TimeRowMobile[], any>({
            path: `/api/mobile/rows`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Packages
     * @name UpgradeGetPackages
     * @request GET:/api/framework/upgrade/packages/{releaseCycle}
     * @secure
     * @response `200` `(UpgradePackageGroup)[]` OK
     */
    upgradeGetPackages = ({ releaseCycle }: UpgradeGetPackagesParams, params: RequestParams = {}) =>
        this.request<UpgradePackageGroup[], any>({
            path: `/api/framework/upgrade/packages/${releaseCycle}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Periods
     * @name CreatePeriod
     * @request POST:/api/periods/create
     * @secure
     * @response `200` `Period` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    createPeriod = (body: PeriodCreation, params: RequestParams = {}) =>
        this.request<Period, ProblemDetails>({
            path: `/api/periods/create`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Periods
     * @name DeletePeriod
     * @request POST:/api/periods/deletePeriod
     * @secure
     * @response `200` `void` OK
     */
    deletePeriod = (body: PeriodDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/periods/deletePeriod`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Periods
     * @name EditPeriod
     * @request POST:/api/periods/edit
     * @secure
     * @response `200` `Period` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    editPeriod = (body: Period, params: RequestParams = {}) =>
        this.request<Period, ProblemDetails>({
            path: `/api/periods/edit`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Periods
     * @name GetAllPeriods
     * @request GET:/api/periods/getAll
     * @secure
     * @response `200` `(Period)[]` OK
     */
    getAllPeriods = (params: RequestParams = {}) =>
        this.request<Period[], any>({
            path: `/api/periods/getAll`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Periods
     * @name GetPeriodsByDates
     * @request GET:/api/periods/getByDates
     * @secure
     * @response `200` `(Period)[]` OK
     */
    getPeriodsByDates = (query: GetPeriodsByDatesParams = {}, params: RequestParams = {}) =>
        this.request<Period[], any>({
            path: `/api/periods/getByDates`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Plugin
     * @name PluginGlobalCreate
     * @request POST:/api/plugin/global
     * @secure
     * @response `200` `void` OK
     */
    pluginGlobalCreate = (body: CreateTrialDatabaseDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/plugin/global`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubDataList
     * @request GET:/api/integration/powerhub/data
     * @secure
     * @response `200` `(any)[]` OK
     */
    integrationPowerhubDataList = (query: IntegrationPowerhubDataListParams = {}, params: RequestParams = {}) =>
        this.request<any[], any>({
            path: `/api/integration/powerhub/data`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubDataCreate
     * @request POST:/api/integration/powerhub/data
     * @secure
     * @response `200` `(any)[]` OK
     */
    integrationPowerhubDataCreate = (body: QueryDataDTO, params: RequestParams = {}) =>
        this.request<any[], any>({
            path: `/api/integration/powerhub/data`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubPaginatedCreate
     * @request POST:/api/integration/powerhub/paginated
     * @secure
     * @response `200` `PaginatedDataResponse` OK
     */
    integrationPowerhubPaginatedCreate = (body: QueryDataDTO, params: RequestParams = {}) =>
        this.request<PaginatedDataResponse, any>({
            path: `/api/integration/powerhub/paginated`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubUpsertPowerhubServicePrincipalCreate
     * @request POST:/api/integration/powerhub/upsertPowerhubServicePrincipal
     * @secure
     * @response `200` `void` OK
     */
    integrationPowerhubUpsertPowerhubServicePrincipalCreate = (body: AddPowerhubServicePrincipalDTO, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/powerhub/upsertPowerhubServicePrincipal`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubGetPowerhubServicePrincipalList
     * @request GET:/api/integration/powerhub/getPowerhubServicePrincipal
     * @secure
     * @response `200` `TimeUser` OK
     */
    integrationPowerhubGetPowerhubServicePrincipalList = (params: RequestParams = {}) =>
        this.request<TimeUser, any>({
            path: `/api/integration/powerhub/getPowerhubServicePrincipal`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubRemovePowerhubServicePrincipalList
     * @request GET:/api/integration/powerhub/removePowerhubServicePrincipal
     * @secure
     * @response `200` `void` OK
     */
    integrationPowerhubRemovePowerhubServicePrincipalList = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/powerhub/removePowerhubServicePrincipal`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubEnableCreate
     * @request POST:/api/integration/powerhub/enable
     * @secure
     * @response `200` `void` OK
     */
    integrationPowerhubEnableCreate = (body: ServiceBusConnection, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/powerhub/enable`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubDisableList
     * @request GET:/api/integration/powerhub/disable
     * @secure
     * @response `200` `void` OK
     */
    integrationPowerhubDisableList = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/powerhub/disable`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubDisableCreate
     * @request POST:/api/integration/powerhub/disable
     * @secure
     * @response `200` `void` OK
     */
    integrationPowerhubDisableCreate = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/integration/powerhub/disable`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubMetadataList
     * @request GET:/api/integration/powerhub/metadata
     * @secure
     * @response `200` `(MetadataTable)[]` OK
     */
    integrationPowerhubMetadataList = (params: RequestParams = {}) =>
        this.request<MetadataTable[], any>({
            path: `/api/integration/powerhub/metadata`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubEntitiesList
     * @request GET:/api/integration/powerhub/entities
     * @secure
     * @response `200` `(string)[]` OK
     */
    integrationPowerhubEntitiesList = (params: RequestParams = {}) =>
        this.request<string[], any>({
            path: `/api/integration/powerhub/entities`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Powerhub
     * @name IntegrationPowerhubOrganizationsList
     * @request GET:/api/integration/powerhub/organizations
     * @secure
     * @response `200` `(OrganizationsDTO)[]` OK
     */
    integrationPowerhubOrganizationsList = (params: RequestParams = {}) =>
        this.request<OrganizationsDTO[], any>({
            path: `/api/integration/powerhub/organizations`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Project-Types
     * @name DataverseProjectTypesSyncCreate
     * @request POST:/api/dataverse/project-types/sync
     * @secure
     * @response `200` `(DataverseProjectType)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseProjectTypesSyncCreate = (params: RequestParams = {}) =>
        this.request<DataverseProjectType[], ProjectumProblemDetails>({
            path: `/api/dataverse/project-types/sync`,
            method: 'POST',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name ApprovalProjectapprovalGetActivitiesList
     * @request GET:/api/approval/projectapproval/getActivities
     * @secure
     * @response `200` `(Activity)[]` OK
     */
    approvalProjectapprovalGetActivitiesList = (params: RequestParams = {}) =>
        this.request<Activity[], any>({
            path: `/api/approval/projectapproval/getActivities`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name ApprovalProjectapprovalGetProjectManagerApprovalsForMonthList
     * @request GET:/api/approval/projectapproval/getProjectManagerApprovalsForMonth
     * @secure
     * @response `200` `ProjectApprovalData` OK
     */
    approvalProjectapprovalGetProjectManagerApprovalsForMonthList = (
        query: ApprovalProjectapprovalGetProjectManagerApprovalsForMonthListParams = {},
        params: RequestParams = {},
    ) =>
        this.request<ProjectApprovalData, any>({
            path: `/api/approval/projectapproval/getProjectManagerApprovalsForMonth`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetApprovedHoursForApproval
     * @request POST:/api/approval/projectapproval/setApprovedHours
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    setApprovedHoursForApproval = (body: SetApprovedHoursForApprovalDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setApprovedHours`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetCustomRateForApproval
     * @request POST:/api/approval/projectapproval/setCustomRate
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    setCustomRateForApproval = (body: SetCustomRateForApprovalDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setCustomRate`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetCustomRateMultiple
     * @request POST:/api/approval/projectapproval/setCustomRateMultiple
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    setCustomRateMultiple = (body: SetMultipleCustomRateForApprovalDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setCustomRateMultiple`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetActivity
     * @request POST:/api/approval/projectapproval/setActivity
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setActivity = (body: SetTimeEntryApprovalActivityDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setActivity`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetMultipleActivity
     * @request POST:/api/approval/projectapproval/setMultipleActivity
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setMultipleActivity = (body: SetMultipleTimeEntryApprovalActivityDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setMultipleActivity`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetApprovalState
     * @request POST:/api/approval/projectapproval/setState
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    setApprovalState = (body: SetTimeEntryApprovalStateDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setState`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projectapproval
     * @name SetMultipleApprovalState
     * @request POST:/api/approval/projectapproval/setMultipleState
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    setMultipleApprovalState = (body: SetMultipleTimeEntryApprovalStateDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/approval/projectapproval/setMultipleState`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projects
     * @name GetAdminProjects
     * @request GET:/api/projects/getAdminProjects
     * @secure
     * @response `200` `(AdminProject)[]` OK
     */
    getAdminProjects = (query: GetAdminProjectsParams = {}, params: RequestParams = {}) =>
        this.request<AdminProject[], any>({
            path: `/api/projects/getAdminProjects`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projects
     * @name GetAllProjectTypes
     * @request GET:/api/projects/types
     * @secure
     * @response `200` `(WorkProjectType)[]` OK
     */
    getAllProjectTypes = (query: GetAllProjectTypesParams = {}, params: RequestParams = {}) =>
        this.request<WorkProjectType[], any>({
            path: `/api/projects/types`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectSources
     * @request GET:/api/projects/getProjectSources
     * @secure
     * @response `200` `(ProjectSource)[]` OK
     */
    getProjectSources = (params: RequestParams = {}) =>
        this.request<ProjectSource[], any>({
            path: `/api/projects/getProjectSources`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Registrations
     * @name RegisterTimeEntry
     * @request POST:/api/registrations/register
     * @secure
     * @response `200` `TimeRegistrationResult` OK
     */
    registerTimeEntry = (body: RegisterTimeDto, params: RequestParams = {}) =>
        this.request<TimeRegistrationResult, any>({
            path: `/api/registrations/register`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Registrations
     * @name RegisterTimeByPeriodDays
     * @request POST:/api/registrations/registertimebyperioddays
     * @secure
     * @response `200` `(string)[]` OK
     */
    registerTimeByPeriodDays = (body: RegisterTimeByPeriodDayDto, params: RequestParams = {}) =>
        this.request<string[], any>({
            path: `/api/registrations/registertimebyperioddays`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Registrations
     * @name RegisterTimeEntries
     * @request POST:/api/registrations/registerTimeEntries
     * @secure
     * @response `200` `(TimeEntry)[]` OK
     */
    registerTimeEntries = (body: RegisterMultipleTimeEntriesDto, params: RequestParams = {}) =>
        this.request<TimeEntry[], any>({
            path: `/api/registrations/registerTimeEntries`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * @description AB8BF533-DB05-4C14-A998-B993D88D7DEA
     *
     * @tags Registrations
     * @name GetRowsByUserReportingPeriodId
     * @request POST:/api/registrations/rows
     * @secure
     * @response `200` `(UserRegistrationPeriod)[]` OK
     */
    getRowsByUserReportingPeriodId = (body: GuidDto, params: RequestParams = {}) =>
        this.request<UserRegistrationPeriod[], any>({
            path: `/api/registrations/rows`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Registrations
     * @name CreateTimeEntry
     * @request POST:/api/registrations/create
     * @secure
     * @response `201` `TimeEntryAdminCreatedDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    createTimeEntry = (body: CreateTimeEntryRequest, params: RequestParams = {}) =>
        this.request<TimeEntryAdminCreatedDto, ProblemDetails>({
            path: `/api/registrations/create`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Releasenotes
     * @name VersioningReleasenotesDetail
     * @request GET:/api/versioning/releasenotes/{version}
     * @secure
     * @response `200` `void` OK
     */
    versioningReleasenotesDetail = ({ version }: VersioningReleasenotesDetailParams, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/versioning/releasenotes/${version}`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * @description Gets SBOM (Software Bill of Materials) for a specific version.
     *
     * @tags Sbom
     * @name GetSbom
     * @request GET:/api/package-artifacts/sbom/{version}
     * @secure
     * @response `200` `string` OK
     * @response `404` `ProblemDetails` Not Found
     */
    getSbom = ({ version }: GetSbomParams, params: RequestParams = {}) =>
        this.request<string, ProblemDetails>({
            path: `/api/package-artifacts/sbom/${version}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name CronValidator
     * @request POST:/api/schedules/cronvalidator
     * @secure
     * @response `200` `void` OK
     */
    cronValidator = (body: CronValidatorPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/cronvalidator`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name DeleteScheduleJob
     * @request POST:/api/schedules/deleteschedulejob
     * @secure
     * @response `200` `void` OK
     */
    deleteScheduleJob = (body: IScheduleJob, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/deleteschedulejob`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name DisableScheduleWebJob
     * @request GET:/api/schedules/disableschedulewebjob
     * @secure
     * @response `200` `void` OK
     */
    disableScheduleWebJob = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/disableschedulewebjob`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name EnableScheduleWebJob
     * @request POST:/api/schedules/enableschedulewebjob
     * @secure
     * @response `200` `void` OK
     */
    enableScheduleWebJob = (body: EnableScheduleWebJobPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/enableschedulewebjob`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name GetScheduleJob
     * @request POST:/api/schedules/getschedulejob
     * @secure
     * @response `200` `void` OK
     */
    getScheduleJob = (body: GetScheduleJobPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/getschedulejob`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name ScheduleJobExecutor
     * @request GET:/api/schedules/schedulejobexecutor
     * @secure
     * @response `200` `void` OK
     */
    scheduleJobExecutor = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/schedulejobexecutor`,
            method: 'GET',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Schedules
     * @name UpsertScheduleJob
     * @request POST:/api/schedules/upsertschedulejob
     * @secure
     * @response `200` `void` OK
     */
    upsertScheduleJob = (body: IScheduleJob, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/schedules/upsertschedulejob`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Search
     * @name GetDefault
     * @request GET:/api/search/getDefault
     * @secure
     * @response `200` `(TimeSearchRow)[]` OK
     */
    getDefault = (params: RequestParams = {}) =>
        this.request<TimeSearchRow[], any>({
            path: `/api/search/getDefault`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Search
     * @name SearchTasks
     * @request GET:/api/search/tasks
     * @secure
     * @response `200` `(TimeSearchRow)[]` OK
     */
    searchTasks = (query: SearchTasksParams = {}, params: RequestParams = {}) =>
        this.request<TimeSearchRow[], any>({
            path: `/api/search/tasks`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Search
     * @name SearchAllTasksAdminOnly
     * @request GET:/api/search/all-tasks
     * @secure
     * @response `200` `(TimeSearchRow)[]` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    searchAllTasksAdminOnly = (query: SearchAllTasksAdminOnlyParams = {}, params: RequestParams = {}) =>
        this.request<TimeSearchRow[], ProblemDetails>({
            path: `/api/search/all-tasks`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Search
     * @name SearchAssigned
     * @request GET:/api/search/assigned
     * @secure
     * @response `200` `(TimeSearchRow)[]` OK
     */
    searchAssigned = (query: SearchAssignedParams = {}, params: RequestParams = {}) =>
        this.request<TimeSearchRow[], any>({
            path: `/api/search/assigned`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Servicebus
     * @name ServicebusClientList
     * @request GET:/api/servicebus/client
     * @secure
     * @response `200` `(PFServiceBusConfiguration)[]` OK
     */
    servicebusClientList = (params: RequestParams = {}) =>
        this.request<PFServiceBusConfiguration[], any>({
            path: `/api/servicebus/client`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Servicebus
     * @name ServicebusInitializeCreate
     * @request POST:/api/servicebus/initialize
     * @secure
     * @response `200` `void` OK
     */
    servicebusInitializeCreate = (body: ServicebusInitializeCreatePayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/initialize`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Servicebus
     * @name ServicebusStartCreate
     * @request POST:/api/servicebus/start
     * @secure
     * @response `200` `void` OK
     */
    servicebusStartCreate = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/servicebus/start`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Sync
     * @name GetAdGroups
     * @request GET:/api/sync/getadgroups
     * @secure
     * @response `200` `(ActiveDirectoryGroup)[]` OK
     */
    getAdGroups = (params: RequestParams = {}) =>
        this.request<ActiveDirectoryGroup[], any>({
            path: `/api/sync/getadgroups`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Tables
     * @name DataverseEnvironmentsTablesColumnsList
     * @request GET:/api/dataverse/environments/tables/columns
     * @secure
     * @response `200` `(ColumnDto)[]` OK
     * @response `500` `ProjectumProblemDetails` Internal Server Error
     */
    dataverseEnvironmentsTablesColumnsList = (query: DataverseEnvironmentsTablesColumnsListParams = {}, params: RequestParams = {}) =>
        this.request<ColumnDto[], ProjectumProblemDetails>({
            path: `/api/dataverse/environments/tables/columns`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Tasks
     * @name PinForUser
     * @request POST:/api/tasks/setpinned
     * @secure
     * @response `200` `void` OK
     */
    pinForUser = (body: SetPinnedDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/tasks/setpinned`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Telemetry
     * @name LogApplicationUsage
     * @request POST:/api/telemetry/logapplicationusage
     * @secure
     * @response `200` `void` OK
     */
    logApplicationUsage = (body: OrgIdContainer, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/telemetry/logapplicationusage`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Telemetry
     * @name LogLicenseUsage
     * @request POST:/api/telemetry/loglicenseusage
     * @secure
     * @response `200` `void` OK
     */
    logLicenseUsage = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/telemetry/loglicenseusage`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Time-Entry
     * @name TimeEntryCorrectionsTimeEntryDetail
     * @request GET:/api/time-entry-corrections/time-entry/{timeEntryId}
     * @secure
     * @response `200` `(CorrectionDto)[]` OK
     */
    timeEntryCorrectionsTimeEntryDetail = ({ timeEntryId }: TimeEntryCorrectionsTimeEntryDetailParams, params: RequestParams = {}) =>
        this.request<CorrectionDto[], any>({
            path: `/api/time-entry-corrections/time-entry/${timeEntryId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Time-Entry-Corrections
     * @name TimeEntryCorrectionsPreviewAssignmentCreate
     * @request POST:/api/time-entry-corrections/preview-assignment
     * @secure
     * @response `200` `AssignmentPreviewDto` OK
     * @response `404` `ProblemDetails` Not Found
     */
    timeEntryCorrectionsPreviewAssignmentCreate = (body: AssignmentPreviewRequest, params: RequestParams = {}) =>
        this.request<AssignmentPreviewDto, ProblemDetails>({
            path: `/api/time-entry-corrections/preview-assignment`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Time-Entry-Corrections
     * @name TimeEntryCorrectionsCreateWithTimeEntryCreate
     * @request POST:/api/time-entry-corrections/create-with-time-entry
     * @secure
     * @response `201` `CorrectionWithTimeEntryDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    timeEntryCorrectionsCreateWithTimeEntryCreate = (body: CreateCorrectionWithTimeEntryRequest, params: RequestParams = {}) =>
        this.request<CorrectionWithTimeEntryDto, ProblemDetails>({
            path: `/api/time-entry-corrections/create-with-time-entry`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Time-Entry-Corrections
     * @name TimeEntryCorrectionsDetail
     * @request GET:/api/time-entry-corrections/{id}
     * @secure
     * @response `200` `CorrectionDto` OK
     * @response `404` `ProblemDetails` Not Found
     */
    timeEntryCorrectionsDetail = ({ id }: TimeEntryCorrectionsDetailParams, params: RequestParams = {}) =>
        this.request<CorrectionDto, ProblemDetails>({
            path: `/api/time-entry-corrections/${id}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Time-Entry-Corrections
     * @name TimeEntryCorrectionsWithinDatesList
     * @request GET:/api/time-entry-corrections/withinDates
     * @secure
     * @response `200` `TimeEntryCorrectionData` OK
     */
    timeEntryCorrectionsWithinDatesList = (query: TimeEntryCorrectionsWithinDatesListParams = {}, params: RequestParams = {}) =>
        this.request<TimeEntryCorrectionData, any>({
            path: `/api/time-entry-corrections/withinDates`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Trial
     * @name CreateDemoDataForTrial
     * @request POST:/api/trial/loaddemodata
     * @secure
     * @response `200` `void` OK
     */
    createDemoDataForTrial = (body: LoginDatabaseDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/trial/loaddemodata`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Upgrade
     * @name UpgradeControllers
     * @request GET:/api/framework/upgrade/controller
     * @secure
     * @response `200` `(UpgradeController)[]` OK
     */
    upgradeControllers = (params: RequestParams = {}) =>
        this.request<UpgradeController[], any>({
            path: `/api/framework/upgrade/controller`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Userperiod
     * @name GetUserPeriodByDate
     * @request GET:/api/users/userperiod/getByDate
     * @secure
     * @response `200` `ReportPeriodDto` OK
     */
    getUserPeriodByDate = (query: GetUserPeriodByDateParams = {}, params: RequestParams = {}) =>
        this.request<ReportPeriodDto, any>({
            path: `/api/users/userperiod/getByDate`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Userperiods
     * @name AddComment
     * @request POST:/api/users/userperiods/addComment
     * @secure
     * @response `200` `void` OK
     */
    addComment = (body: UserReportingPeriodComment, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/users/userperiods/addComment`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Userperiods
     * @name CopyTimeEntriesFromExistingUserPeriod
     * @request POST:/api/users/userperiods/copyfromuserperiod
     * @secure
     * @response `200` `(UserRegistrationPeriod)[]` OK
     */
    copyTimeEntriesFromExistingUserPeriod = (body: CopyTime, params: RequestParams = {}) =>
        this.request<UserRegistrationPeriod[], any>({
            path: `/api/users/userperiods/copyfromuserperiod`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Userperiods
     * @name CopyTimeEntriesFromPreviousUserPeriod
     * @request POST:/api/users/userperiods/copyfromprevious
     * @secure
     * @response `200` `ReportPeriodDto` OK
     */
    copyTimeEntriesFromPreviousUserPeriod = (query: CopyTimeEntriesFromPreviousUserPeriodParams = {}, params: RequestParams = {}) =>
        this.request<ReportPeriodDto, any>({
            path: `/api/users/userperiods/copyfromprevious`,
            method: 'POST',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * @description 8FE0378D-6AF2-4D86-957D-0C4F9A039541
     *
     * @tags Userperiods
     * @name SetReportingPeriodState
     * @request POST:/api/users/userperiods/setState
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    setReportingPeriodState = (body: SetUserPeriodStateDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/users/userperiods/setState`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Userperiods
     * @name SetWorkday
     * @request POST:/api/users/userperiods/setworkday
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    setWorkday = (body: SetWorkDayStartEndDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/users/userperiods/setworkday`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SetAdminProjects
     * @request POST:/api/users/setAdminProjects
     * @secure
     * @response `200` `void` OK
     */
    setAdminProjects = (body: SetAdminProjectsPayload, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/users/setAdminProjects`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name DeleteUser
     * @request POST:/api/users/delete
     * @secure
     * @response `200` `boolean` OK
     */
    deleteUser = (body: DeleteUserDto, params: RequestParams = {}) =>
        this.request<boolean, any>({
            path: `/api/users/delete`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name GetUsersByApprover
     * @request GET:/api/users/byapprover
     * @secure
     * @response `200` `(TimeUser)[]` OK
     * @response `500` `void` Internal Server Error
     */
    getUsersByApprover = (params: RequestParams = {}) =>
        this.request<TimeUser[], void>({
            path: `/api/users/byapprover`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SearchUsers
     * @request GET:/api/users/searchUsers
     * @secure
     * @response `200` `(TimeUser)[]` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    searchUsers = (query: SearchUsersParams = {}, params: RequestParams = {}) =>
        this.request<TimeUser[], ProblemDetails>({
            path: `/api/users/searchUsers`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SetApprover
     * @request POST:/api/users/setApprover
     * @secure
     * @response `200` `void` OK
     */
    setApprover = (body: SetApproverDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/users/setApprover`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SetAutoApprovalForUser
     * @request POST:/api/users/autoapprove
     * @secure
     * @response `200` `void` OK
     * @response `500` `void` Internal Server Error
     */
    setAutoApprovalForUser = (body: SetAutoApproveDto, params: RequestParams = {}) =>
        this.request<void, void>({
            path: `/api/users/autoapprove`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SetIsAdmin
     * @request POST:/api/users/setIsAdmin
     * @secure
     * @response `200` `void` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    setIsAdmin = (body: SetIsAdminDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails>({
            path: `/api/users/setIsAdmin`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name SetBasicAdministrativeUserProperties
     * @request POST:/api/users/setBasics
     * @secure
     * @response `200` `void` OK
     */
    setBasicAdministrativeUserProperties = (body: SetUserAdministrationDto, params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/users/setBasics`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name UsersCalendarList
     * @request GET:/api/users/calendar
     * @secure
     * @response `200` `Calendar` OK
     */
    usersCalendarList = (query: UsersCalendarListParams = {}, params: RequestParams = {}) =>
        this.request<Calendar, any>({
            path: `/api/users/calendar`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Users
     * @name ClearUserCache
     * @request POST:/api/cache/users/clear
     * @secure
     * @response `200` `void` OK
     */
    clearUserCache = (params: RequestParams = {}) =>
        this.request<void, any>({
            path: `/api/cache/users/clear`,
            method: 'POST',
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags Validation
     * @name ValidationPowerautomateCreate
     * @request POST:/api/validation/powerautomate
     * @secure
     * @response `200` `PowerAutomateValidationResponse` OK
     * @response `400` `ProblemDetails` Bad Request
     */
    validationPowerautomateCreate = (body: PowerAutomateFlowValidationRequest, params: RequestParams = {}) =>
        this.request<PowerAutomateValidationResponse, ProblemDetails>({
            path: `/api/validation/powerautomate`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Worktypes
     * @name GetAllowedWorkTypes
     * @request GET:/api/worktypes/allowed
     * @secure
     * @response `200` `(WorkType)[]` OK
     * @response `500` `void` Internal Server Error
     */
    getAllowedWorkTypes = (query: GetAllowedWorkTypesParams = {}, params: RequestParams = {}) =>
        this.request<WorkType[], void>({
            path: `/api/worktypes/allowed`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
}
